/* ==========================================================================
   BOOST CUSTOMISATION 2026-06-20 - Decoration Awareness (Promo + Drawer)
   assets/boost-decoration.js

   Self-contained controller for the shared Decoration Options drawer
   (snippets/boost-decoration-drawer.liquid). No theme or library dependency,
   so it cannot collide with the cart's async panel system.

   Responsibilities: open / close, ESC to close, overlay click to close, focus
   trap, scroll lock, and returning focus to the trigger on close. Triggered by
   any element carrying [data-boost-deco-open]. Event delegation means it works
   for every promo row on the page against the one drawer instance.
   ========================================================================== */
(function () {
  'use strict';

  var DRAWER_ID = 'boost-deco-drawer';
  var OPEN_CLASS = 'is-open';
  var HTML_LOCK_CLASS = 'boost-deco-drawer-open';

  var drawer = null;
  var root = null;
  var overlay = null;
  var lastFocused = null;

  function focusable(container) {
    var nodes = container.querySelectorAll(
      'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])'
    );
    return Array.prototype.slice.call(nodes).filter(function (el) {
      return el.offsetWidth > 0 || el.offsetHeight > 0 || el === document.activeElement;
    });
  }

  function onKeydown(e) {
    var key = e.key || e.keyCode;
    if (key === 'Escape' || key === 'Esc' || key === 27) {
      e.preventDefault();
      close();
      return;
    }
    if (key === 'Tab' || key === 9) {
      var items = focusable(drawer);
      if (!items.length) {
        e.preventDefault();
        drawer.focus();
        return;
      }
      var first = items[0];
      var last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  }

  function open(trigger) {
    drawer = document.getElementById(DRAWER_ID);
    if (!drawer) { return; }
    root = drawer.closest('[data-boost-deco-root]') || drawer.parentNode;
    overlay = root.querySelector('[data-boost-deco-overlay]');
    lastFocused = trigger || document.activeElement;

    if (overlay) { overlay.hidden = false; }
    /* Force a reflow so the overlay fade-in transition runs from opacity 0. */
    if (overlay) { void overlay.offsetWidth; }

    root.classList.add(OPEN_CLASS);
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add(HTML_LOCK_CLASS);

    var closeBtn = drawer.querySelector('[data-boost-deco-close]');
    (closeBtn || drawer).focus();

    document.addEventListener('keydown', onKeydown);
  }

  function close() {
    if (!drawer || !root) { return; }
    root.classList.remove(OPEN_CLASS);
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove(HTML_LOCK_CLASS);
    document.removeEventListener('keydown', onKeydown);

    if (overlay) {
      window.setTimeout(function () {
        if (drawer && drawer.getAttribute('aria-hidden') === 'true') {
          overlay.hidden = true;
        }
      }, 320);
    }

    if (lastFocused && typeof lastFocused.focus === 'function') {
      lastFocused.focus();
    }
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest && e.target.closest('[data-boost-deco-open]');
    if (opener) {
      e.preventDefault();
      open(opener);
      return;
    }
    var closer = e.target.closest && e.target.closest('[data-boost-deco-close], [data-boost-deco-overlay]');
    if (closer) {
      e.preventDefault();
      close();
    }
  });

  /* Promo trigger and the drawer close are spans, so support keyboard activation. */
  document.addEventListener('keydown', function (e) {
    var activate = e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar' || e.keyCode === 13 || e.keyCode === 32;
    if (!activate) { return; }
    var opener = e.target.closest && e.target.closest('[data-boost-deco-open]');
    if (opener) {
      e.preventDefault();
      open(opener);
      return;
    }
    var closer = e.target.closest && e.target.closest('[data-boost-deco-close]');
    if (closer) {
      e.preventDefault();
      close();
    }
  });
})();
